//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
let d=[[[1,"BodySelection",0,"ScCollector",0],[0,"CurrentBody",1,"NXObject",0],[1,"FaceToPatch",0,"ScCollector",0],[1,"HoleFace",0,"ScCollector",0],[0,"MergeOutput",1,0],[0,"SelectionType",1,0]],[[["edges","faces"],"AddHolesData",{},2,0],[["object","highlight"],"SetHighlight",{},2,0],[["holeName"],"RemoveHoleData",{},1,0],[[],"ClearHoleData",{},0,0]],[]];
SPLM.Tooling.RemoveHolesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.RemoveHolesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.RemoveHolesBuilder.SelectionTypes = Object.freeze({
    "Body" : "Body", "Face" : "Face"});

export default SPLM;